import { SqlResultActionType } from '@mode/legacy/util-domain';

export namespace SqlResultActions {
  export const Type = SqlResultActionType;

  export class SetOffset {
    public readonly type = Type.SetOffset;
    constructor(
      public readonly token: string,
      public readonly offset: number
    ) {}
  }

  export class SetPageSize {
    public readonly type = Type.SetPageSize;
    constructor(
      public readonly token: string,
      public readonly pageSize: number
    ) {}
  }
}

export type SqlResultActions = SqlResultActions.SetOffset | SqlResultActions.SetPageSize;
